import { displayToast } from '../../components/Toaster/displayToast';
import generateHeaders from '../myHeaders';

const deleteUserFromMailingList = (
    mailingListId: string,
    userId: string,
    successMessage: string,
    errorMessage: string,
    selectedSchema: string,
) => {
    const url = `${process.env.REACT_APP_API_URL}/mailing_list/${mailingListId}/user/${userId}`;

    const requestOptions = {
        method: 'DELETE',
        headers: generateHeaders(selectedSchema),
    };

    fetch(url, requestOptions)
        .then((response) => {
            if (!response.ok) {
                displayToast(errorMessage, 'error');
            } else {
                displayToast(successMessage, 'success');
            }
        }).catch(() => {
            displayToast(errorMessage, 'error');
        });
};

export default deleteUserFromMailingList;
